import { GetterTree } from 'vuex'
import { EnergyProductionState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<EnergyProductionState, RootState> = {}
